import styled, { keyframes } from "styled-components";
import AvisoMoverPrivado from "../../common/AvisoMoverPrivado";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useEffect, useState, ChangeEvent } from "react";
import { Reservation, Tour, PaymentMethods } from "../../../types/common.types";
import InputDropdown from "../../common/InputDropdown";
import ToursService from "../../../services/tours.service";
import GeneralInput from "../../common/GeneralInput";
import Calendar from "../../common/CalendarInput";
import { format } from "date-fns";
import removeTimezone from "../../../utils/removeTimezone";
import { FaTrash } from "react-icons/fa";
import Dropdown from "../../common/Dropdown";
import insert from "../../../utils/insert";
import dollar from '../../../assets/common/dollar.svg'
import { useAdmin } from "../../../context/admin";
import { add } from "date-fns";
import AdminService from "../../../services/admin.service";
import { useGlobal } from "../../../context/global";

export default function EditReservation() {
    const { setMessage, setIsLoading } = useGlobal()
    const {setEditReservationId, setCurrentDay, editReservationId} = useAdmin()
    const [data, setData] = useState<Reservation>({} as Reservation)
    const [moverTrip, setMoverTrip] = useState(false)
    const [initialData, setInitialData] = useState<Reservation>({} as Reservation)
    const [tours, setTours] = useState<Tour[]>([])

    async function recalcularEntradas() {
        if (!editReservationId) return
        try {
            const { tickets } = (await AdminService.recalcularEntradas(editReservationId)).data
            // Se actualiza también lo "inicial": guardar después no lo vuelve a marcar como manual.
            setData(prev => ({ ...prev, tickets, tickets_manual: false } as any))
            setInitialData(prev => ({ ...prev, tickets, tickets_manual: false } as any))
        } catch (error: any) {
            setMessage({ type: 'error', content: typeof error?.response?.data === 'string' ? error.response.data : 'No se pudo recalcular' })
            setTimeout(() => setMessage(undefined), 5000)
        }
    }
    useEffect(() => {
        async function getInfo() {
            setIsLoading(true)
            try {
                if (!editReservationId) return
                const response: Reservation = (await AdminService.getReservation(editReservationId)).data
                // Privado: se edita el vehículo completo (precio y pagos de todos) y el backend lo reparte.
                setData(response.vehiculo ? {...response, price: response.vehiculo.price, payment_methods: response.vehiculo.payment_methods} : response)
                setInitialData(response)
            } catch (error) {
                console.log(error)
            }
            try {
                const response = await (await ToursService.list()).data
                setTours(response)
            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        getInfo()
    }, [])
    function onSelectPayment(newMethod: string) {
        const new_data = data.payment_methods ? [...data.payment_methods, {name: newMethod}] : [{name: newMethod}]
        setData(prevData => ({...prevData, payment_methods: new_data}))
    }
    function onChangePayment(e: ChangeEvent<HTMLInputElement>) {
        const value = Number(e.target.value)
        const name = e.target.name
        if (!data.payment_methods) {
            const newList = [{name, value}]
            setData(prevData => ({...prevData, payment_methods: newList}))
            return
        }
        const oldItem = data.payment_methods.find((item: PaymentMethods) => item.name === name)
        if (!oldItem) return
        const index = data.payment_methods.indexOf(oldItem)
        console.log(index)
        const filteredList = [...data.payment_methods.filter((item: PaymentMethods) => item.name !== name)]
        const newData = {...oldItem, value}
        setData(prevData => ({...prevData, payment_methods: insert(filteredList, index, newData)}))
    }

    function deletePayment(name: string) {
        const newList = data.payment_methods.filter((item: PaymentMethods) => item.name !== name)
        setData(prevData => ({...prevData, payment_methods: newList}))
    } 

    async function onSubmit() {
        if (!editReservationId) return
        if (data?.reservation_date && data?.tour_id) {
            if (!tours.some(tour => tour.id === data.tour_id)) return
            const newData: Reservation = {
                tour_id: data.tour_id,
                reservation_date: data.reservation_date,
                tickets: data.tickets,
                price: data.price,
                payment_methods: data.payment_methods,
                cost: data.cost,
                traspass_price: data.traspass_price,
                vehiculo: !!data.vehiculo,
                mover_trip: moverTrip
            } as any
            try {
                setIsLoading(true)
                const response = await AdminService.editReservation(editReservationId, newData)
                setEditReservationId(undefined)
                setMessage({type: 'success', content: response.data})
                setTimeout(() => {
                    setMessage(undefined)
                }, 2500)
                await setCurrentDay((prevDay: Date) => add(prevDay, {days: 1}))
                await setCurrentDay((prevDay: Date) => add(prevDay, {days: -1}))
            } catch (error: any) {
                console.log(error)
                if (typeof error?.response?.data === 'string') {
                    setMessage({type: 'error', content: error.response.data})
                    setTimeout(() => setMessage(undefined), 6000)
                }
            } finally {
                setIsLoading(false)
            }
        }
    }

    return (
        <Main>
            <Modal>
                <div className="close" title="close"
                    onClick={() => setEditReservationId(undefined)}
                >
                    <AiOutlineCloseCircle/>
                </div>
                <h1>Edit reservation</h1>
                {
                    tours.length > 0 &&
                    <InputDropdown
                    options={tours}
                    keys={['id']}
                    value={data.tour_id}
                    selector="id"
                    optionDefaultHeight={35}
                    onChange={(newValue: string) => setData(prevData => ({...prevData, tour_id: newValue}))}
                    />
                }
                {
                    data.vehiculo &&
                    <p style={{margin: '10px 0', padding: '8px 10px', borderRadius: '6px', backgroundColor: '#e0f2fe', color: '#075985', fontSize: '14px'}}>
                        Tour privado de {data.vehiculo.pasajeros} pasajeros: el precio y los pagos son los del vehículo completo y se dividen entre los {data.vehiculo.pasajeros}.
                    </p>
                }
                {
                    data.reservation_date &&
                    <div 
                    style={{margin: '20px 0'}}
                    className="calendar">
                        <Calendar
                        selectedDay={data.reservation_date}
                        setSelectedDay={(newDate: Date) => setData(prevData => ({...prevData, reservation_date: newDate}))}
                        />
                        {removeTimezone(data.reservation_date.toString())}
                    </div>
                }
                <AvisoMoverPrivado
                vehiculo={data.vehiculo}
                cambio={data.tour_id !== initialData?.tour_id || data.reservation_date !== initialData?.reservation_date}
                mismoTour={data.tour_id === initialData?.tour_id}
                moverTrip={moverTrip}
                setMoverTrip={setMoverTrip}
                />
                <GeneralInput
                label="Ticket price"
                type="number"
                value={data.tickets || ''}
                onChange={e => setData(prevData => ({...prevData, tickets: Number(e.target.value)}))}
                />
                {
                    // Reservas de aliados: las entradas se calculan solas. Si alguien cambia el monto, queda
                    // marcado como manual y deja de recalcularse (ej. un estudiante acreditado).
                    (data as any).tickets_manual && (data as any).passenger?.ally_id &&
                    <p className="aviso-entradas">
                        Monto de entradas cargado a mano: ya no se recalcula solo si cambia el tour o la fecha.
                        <button type="button" onClick={recalcularEntradas}>Volver a calcular</button>
                    </p>
                }
                <GeneralInput
                label={data.vehiculo ? "Precio del privado (vehículo completo)" : "Sale price"}
                type="number"
                style={{margin: '20px 0'}}
                value={data.price || ''}
                onChange={e => setData(prevData => ({...prevData, price: Number(e.target.value)}))}
                />
                <h3 className="payment-title">{data.vehiculo ? 'Pagos del vehículo (total)' : 'Payment methods'}</h3>
                {
                    data?.payment_methods?.map((method, idx: number) => {
                        // Pagos de una compra en la web: se muestran y se guardan tal cual, sin editar ni
                        // borrar. { method: 'WEBPAY', amount } es lo que se cobra al reservar; cuando
                        // Transbank confirma, se agrega { webpay_data, processed_at } con su respuesta.
                        const web = method as any
                        if (web.method) {
                            const confirmado = data.payment_methods.some((m: any) => m.webpay_data)
                            return (
                                <p className="pago-web" key={idx}>
                                    Webpay{confirmado ? ' (pagado en la web)' : ' pendiente de pago'}: <strong>${Number(web.amount || 0).toLocaleString('es-CL')}</strong>
                                </p>
                            )
                        }
                        if (web.webpay_data) {
                            const w = web.webpay_data
                            return (
                                <p className="pago-web detalle" key={idx}>
                                    Comprobante Transbank: autorización {w.authorization_code || '—'}
                                    {w.card_detail?.card_number ? ` · tarjeta terminada en ${w.card_detail.card_number}` : ''}
                                    {w.amount ? ` · total de la compra $${Number(w.amount).toLocaleString('es-CL')}` : ''}
                                </p>
                            )
                        }
                        return (
                            <div className="payment_method" key={idx}>
                                <button
                                onClick={() => deletePayment(method.name)}
                                >
                                    <FaTrash/>
                                </button>
                                <GeneralInput
                                value={method.value || ''}
                                name={method.name}
                                type="number"
                                placeholder="Amount"
                                label={method.name}
                                image={dollar}
                                onChange={onChangePayment}
                                />
                            </div>
                        )
                    })
                }
                <Dropdown
                style={{marginTop: '20px'}}
                options={['Efectivo', 'Tarjeta Santander', 'Tarjeta BCI', 'Trasnferencia Santander', 'Transferencia BCI', 'Wise David', 'Link de Pago', 'Deuda'].filter(str => !data?.payment_methods?.map(item => item.name).includes(str))}
                title="Payment methods"
                onSelect={onSelectPayment}
                />
                {
                    initialData.traspass_price !== undefined &&
                    initialData.traspass_price !== null &&
                    Number(initialData.traspass_price) > 0 &&
                    <GeneralInput
                    label="Traspass Price"
                    type="number"
                    value={data.traspass_price || ''}
                    style={{ marginBottom: '20px' }}
                    onChange={e => setData(prevData => ({...prevData, traspass_price: Number(e.target.value)}))}
                    />
                }
                <GeneralInput
                label="Cost"
                type="number"
                value={data.cost || ''}
                onChange={e => setData(prevData => ({...prevData, cost: Number(e.target.value)}))}
                />
                <button 
                type="submit"
                onClick={onSubmit}
                >Submit</button>
            </Modal>
        </Main>
    )
}

const Main = styled.div`
z-index: 100;
position: fixed;
top: 0;
left: 0;
width: 100vw;
height: 100vh;
background-color: ${props => props.theme.blackTransparent};
`
const showUpModal = keyframes`
    from {
        top: 100%;
    }
    to {
        top: 50%;
    }
`

const Modal = styled.div`
width: 80%;
max-height: 75%;
overflow: hidden;
overflow-y: unset;
max-width: 500px;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
background-color: ${props => props.theme.white};
box-shadow: 0 0 20px ${props => props.theme.blackTransparent};
padding: 20px;
animation: ${showUpModal} .3s ease forwards;
.close {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 22px;
    cursor: pointer;
}
h1 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
}
.payment_method {
    margin-bottom: 10px;
    position: relative;
    button {
        position: absolute;
        right: 0;
        top: 0;
        height: 25px;
        width: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        background-color: rgba(0,0,0,0);
        border-radius: 50%;
        cursor: pointer;
        border: 1px solid ${props => props.theme.dark};
    }
    h4 {
        font-weight: 400;
        margin-bottom: 5px;
    }
    label {
        text-transform: capitalize;
    }
}
> button.back {
    background-color: rgba(0,0,0,0);
    border: none;
    font-size: 20px;
    cursor: pointer;
    transition: transform .3s ease;
    &:hover {
        transform: translateY(-3px);
    }
}
p.pago-web {
    margin: 8px 0;
    font-size: 14px;
}
p.pago-web.detalle {
    margin-top: -4px;
    font-size: 12px;
    color: #777;
}
p.aviso-entradas {
    margin: 6px 0 0;
    font-size: 13px;
    color: #8a5a00;
    button {
        margin-left: 8px;
        border: none;
        border-radius: 6px;
        padding: 4px 10px;
        background: #f2ebe0;
        cursor: pointer;
    }
}
h3.payment-title {
    font-weight: 500;
    margin-bottom: 10px;
}
> .calendar {
    display: flex;
    gap: 10px;
    align-items: center;
}
> button {
    margin-top: 20px;
    display: inline-block;
    padding: 0 10px;
    height: 2.6em;
    line-height: 2.5em;
    overflow: hidden;
    font-size: 17px;
    z-index: 1;
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.blue};
    border: 2px solid ${props => props.theme.blue};
    border-radius: 6px;
    position: relative;
    cursor: pointer;
}

> button::before {
    position: absolute;
    content: "";
    background: ${props => props.theme.blue};
    width: calc(100% + 100px);
    height: 200px;
    z-index: -1;
    border-radius: 50%;
}

> button:hover {
    color: ${props => props.theme.white};
}

> button:before {
    top: 100%;
    left: 100%;
    transition: .3s all;
}

> button:hover::before {
    top: -30px;
    left: -30%;
}
`